import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { updateFeedback } from "@/redux/slices/feedbackSlice";
import { toast } from "react-toastify";
const Edit = ({ showModal, setShowModal, feedbackEdit }) => {
  const { loading } = useSelector((state) => state.feedback);

  const dispatch = useDispatch();

  const [editedComment, setEditedComment] = useState(feedbackEdit.comments);
  const [editedRating, setEditedRating] = useState(feedbackEdit.rating || 0);
  const handleUpdate = (e) => {
    e.preventDefault();
    try {
      dispatch(
        updateFeedback({
          feedbackId: feedbackEdit.feedbackId,
          comments: editedComment,
          rating: editedRating,
        })
      ).unwrap();
    } catch (e) {
      toast.error(e.message);
      return;
    }

    setShowModal(false);
    toast.success("Chỉnh sửa phản hồi thành công");
  };
  useEffect(() => {
    setEditedRating(feedbackEdit.rating);
    setEditedComment(feedbackEdit.comments);
  }, [feedbackEdit]); // Khi feedbackEdit thay đổi, cập nhật lại editedRating
  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header>
        <h5>Chỉnh sửa đánh giá</h5>
        <a
          href="#"
          data-bs-dismiss=""
          className="btn-close text-dark"
          style={{ margin: 0, position: "absolute", right: "16px" }}
          onClick={(e) => {
            e.preventDefault();
            setShowModal(false);
          }}
        ></a>
      </Modal.Header>

      <Form onSubmit={handleUpdate}>
        <Modal.Body>
          {/* Rating Selection */}
          {editedRating > 0 ? (
            <Form.Group className="mb-3">
              <Form.Label className="form-label">
                Đánh giá của bạn <span className="text-danger">*</span>
              </Form.Label>
              <div className="selection-wrap">
                <div className="d-inline-block">
                  <div className="rating-selction">
                    <input
                      type="radio"
                      name="rating"
                      value="5"
                      id="rating5"
                      checked={editedRating === 5}
                      onChange={(e) => setEditedRating(5)}
                    />
                    <label for="rating5">
                      <i className="fa-solid fa-star"></i>
                    </label>
                    <input
                      type="radio"
                      name="rating"
                      value="4"
                      id="rating4"
                      checked={editedRating === 4}
                      onChange={(e) => setEditedRating(4)}
                    />
                    <label for="rating4">
                      <i className="fa-solid fa-star"></i>
                    </label>
                    <input
                      type="radio"
                      name="rating"
                      value="3"
                      id="rating3"
                      checked={editedRating === 3}
                      onChange={(e) => setEditedRating(3)}
                    />
                    <label for="rating3">
                      <i className="fa-solid fa-star"></i>
                    </label>
                    <input
                      type="radio"
                      name="rating"
                      value="2"
                      id="rating2"
                      checked={editedRating === 2}
                      onChange={(e) => setEditedRating(2)}
                    />
                    <label for="rating2">
                      <i className="fa-solid fa-star"></i>
                    </label>
                    <input
                      type="radio"
                      name="rating"
                      value="1"
                      id="rating1"
                      checked={editedRating === 1}
                      onChange={(e) => setEditedRating(1)}
                    />
                    <label for="rating1">
                      <i className="fa-solid fa-star"></i>
                    </label>
                  </div>
                </div>
              </div>
            </Form.Group>
          ) : (
            ""
          )}

          {/* Review Textarea */}
          <Form.Group className="mb-3">
            <Form.Label>
              Chỉnh sửa đánh giá của bạn <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={editedComment}
              onChange={(e) => setEditedComment(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            onClick={(e) => {
              e.preventDefault();
              setShowModal(false);
            }}
          >
            Hủy bỏ
          </Button>
          <Button type="submit" variant="primary">
            Lưu thay đổi
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default Edit;
